import {
    CUSTOM_PLAN, SET_STEPPER,
} from '../../constants/actionType';
import {
    postCreativeApi,
    postCampaignApi,
    postGlobalCreativeListApi,
    getCreativeNameListApi
} from "../../api/creative";

export const customPlanReduxAction = ({ customDetailsForm, customPlanResponse }) => async dispatch => {
    try {
        console.log("customDetailsForm", customDetailsForm)
        console.log("customPlanResponse", customPlanResponse)

        let customPlanData = { customDetailsForm: customDetailsForm, customPlanResponse: customPlanResponse };
        dispatch({
            type: CUSTOM_PLAN,
            customPlanData
        });
    } catch (err) {
    } finally {

    }
};

export const setStepperEditAction = ({ stepperValue, screen }) => async dispatch => {
    try {
        let stepperData = { stepperValue: stepperValue, screen: screen };

        dispatch({
            type: SET_STEPPER,
            stepperData
        });
    } catch (err) {
    } finally {

    }
};